/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import {makeStyles} from '@material-ui/core/styles';
import {useDispatch, useSelector} from 'react-redux';
import {SELECTOR_UI_LOADING_FULFILLMENT} from '../../redux/selectors/uiConfig';
import {SELECTOR_ADDRESS_MAIN} from '../../redux/selectors/addresses';
import {setLoadingFulfillment} from '../../redux/actions/uiConfig';
import {getFulfillments, setFulfillmentSelected, setResetFulfillment} from '../../redux/actions/fulfillments';
import {SELECTOR_SHOPPING_CART_ID, SELECTOR_SHOPPING_CART_PRODUCTS_COUNT} from '../../redux/selectors/shoppingCart';
import {SELECTOR_FULFILLMENTS} from '../../redux/selectors/fulfillments';
import {ViewServiceDeliveryItem} from './viewServiceDeliveryItem';
import {SELECTOR_USER} from '../../redux/selectors/auth';
import api from '../../services/api';
import numeral from 'numeral';

const useStyles = makeStyles({
  subtitle: {
    fontSize: '1rem',
    fontWeight: 600,
  },
});

export function ViewServiceDeliveryList() {
  const loading = useSelector(SELECTOR_UI_LOADING_FULFILLMENT);
  const user = useSelector(SELECTOR_USER);
  const address = useSelector(SELECTOR_ADDRESS_MAIN);
  const shoppingCartId = useSelector(SELECTOR_SHOPPING_CART_ID);
  const fulfillments = useSelector(SELECTOR_FULFILLMENTS);
  const productsCount = useSelector(SELECTOR_SHOPPING_CART_PRODUCTS_COUNT);

  const [dataCredit, setDataCredit] = useState({});

  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      if (user?.id && address?.id && shoppingCartId) {
        dispatch(setFulfillmentSelected(0));
        dispatch(setLoadingFulfillment(true));
        dispatch(getFulfillments())
          .then(() => {
            dispatch(setLoadingFulfillment(false));
          })
          .catch(() => {
            dispatch(setLoadingFulfillment(false));
          });
      } else {
        dispatch(setLoadingFulfillment(false));
        dispatch(setResetFulfillment());
      }
    }, 1000);
    if (user.dni) {
      api.searchCreditCompany.find().then((it) => {
        setDataCredit(it.credit);
      });
    }
  }, [user?.id, address?.id, shoppingCartId, productsCount]);

  const faltantedata = React.useMemo(() => fulfillments.find((obj) => obj.hasOwnProperty('faltante')), [fulfillments]);

  return (
    <React.Fragment>
      <Box mb={1} clone>
        <Typography className={classes.subtitle} color="textPrimary">
          Medios de envío
        </Typography>
      </Box>
      {faltantedata?.faltante && fulfillments.filter((objeto) => objeto?.fulfillment_company_id === 5).length === 0 ? (
        <div style={{boxShadow: '0px 0px 3px #5252526e', padding: 10, background: '#f7f7f7'}}>
          <h3 style={{fontSize: 16, color: 'red', textAlign: 'center', margin: 0}}>
            Te hacen falta {numeral(faltantedata?.faltante).format('$0,0 COP')} para envío gratis.
          </h3>
        </div>
      ) : null}
      <Box my={1}>
        {loading ? (
          <LinearProgress />
        ) : !!fulfillments.length ? (
          fulfillments
            .filter((fulfillment) => {
              if (typeof dataCredit?.credit !== 'undefined') {
                if (fulfillment.price === 0 && fulfillment.fulfillment_company_id === 5)
                  return dataCredit.credit === 'true';
                return fulfillment.fulfillment_company_id !== 5 && !fulfillment.hasOwnProperty('faltante');
              } else {
                return fulfillment.fulfillment_company_id !== 5 && !fulfillment.hasOwnProperty('faltante');
              }
            })
            .map((fulfillment, i) => {
              return <ViewServiceDeliveryItem key={i} fulfillment={fulfillment} />;
            })
        ) : address && address.id ? (
          'No existen métodos de envío para la ciudad seleccionada.'
        ) : (
          'Selecciona una dirección para conocer los métodos de envío.'
        )}
      </Box>
    </React.Fragment>
  );
}
